<script lang="ts">
  export let size = 20;
</script>

<svg width={size} height={size} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M6.2487 1.33325C4.50203 1.33325 3.08203 2.75325 3.08203 4.49992C3.08203 6.21325 4.42203 7.59992 6.1687 7.65992C6.22203 7.65325 6.27537 7.65325 6.31537 7.65992C6.3287 7.65992 6.33536 7.65992 6.3487 7.65992C6.35536 7.65992 6.35537 7.65992 6.36203 7.65992C8.0687 7.59992 9.4087 6.21325 9.41537 4.49992C9.41537 2.75325 7.99537 1.33325 6.2487 1.33325Z"
    class={$$props.class || "fill-current"}
  />
  <path
    d="M9.63859 9.43342C7.77859 8.19342 4.74526 8.19342 2.87193 9.43342C2.02526 10.0001 1.55859 10.7668 1.55859 11.5868C1.55859 12.4068 2.02526 13.1668 2.86526 13.7268C3.79859 14.3534 5.02526 14.6668 6.25193 14.6668C7.47859 14.6668 8.70526 14.3534 9.63859 13.7268C10.4786 13.1601 10.9453 12.4001 10.9453 11.5734C10.9386 10.7534 10.4786 9.99342 9.63859 9.43342Z"
    class={$$props.class || "fill-current"}
  />
  <path
    d="M13.5763 4.89332C13.6829 6.18665 12.7629 7.31999 11.4896 7.47332C11.4829 7.47332 11.4829 7.47332 11.4763 7.47332H11.4562C11.4162 7.47332 11.3762 7.47332 11.3429 7.48665C10.6962 7.51998 10.1029 7.31332 9.65625 6.93332C10.3429 6.31998 10.7363 5.39999 10.6563 4.39999C10.6096 3.85999 10.4229 3.36665 10.1429 2.94665C10.3963 2.81999 10.6896 2.73999 10.9896 2.71332C12.2963 2.59999 13.4629 3.57332 13.5763 4.89332Z"
    class={$$props.class || "fill-current"}
  />
  <path
    d="M14.9115 11.0599C14.8581 11.7066 14.4448 12.2666 13.7515 12.6466C13.0848 13.0133 12.2448 13.1866 11.4115 13.1666C11.8915 12.7333 12.1715 12.1933 12.2248 11.6199C12.2915 10.7933 11.8981 9.99994 11.1115 9.36661C10.6648 9.01327 10.1448 8.73327 9.57812 8.52661C11.0515 8.09994 12.9048 8.38661 14.0448 9.30661C14.6581 9.79994 14.9715 10.4199 14.9115 11.0599Z"
    class={$$props.class || "fill-current"}
  />
</svg>
